import { Mode, ModeTransitionProps } from "@/modes/mode";
import { changeMode } from "@/store/mode-slice";
import {
  resetAlignmentWizard,
  setControlPointsAlignmentEnabled,
} from "@/store/modes/alignment-wizard-mode-slice";
import { useAppDispatch } from "@/store/store-hooks";
import { useEffect } from "react";
import { AlignWizardModeOverlay } from "./align-wizard-mode-overlay";
import { AlignWizardModeScene } from "./align-wizard-mode-scene";

export const alignWizardMode: Mode = {
  name: "alignWizard",
  ModeScene: AlignWizardModeScene,
  ModeOverlay: AlignWizardModeOverlay,
  hasCustomCanvasStyle: true,
  ModeTransition: AlignWizardModeTransition,
  exclusive: {
    title: "Alignment",
    onBack({ dispatch }) {
      dispatch(resetAlignmentWizard());
      dispatch(changeMode("sheet"));
      return Promise.resolve();
    },
  },
};

function AlignWizardModeTransition({ onCompleted }: ModeTransitionProps): null {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setControlPointsAlignmentEnabled(false));
    onCompleted();
  }, [dispatch, onCompleted]);

  return null;
}
